var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3217_23478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0698 10.6046L5.58142 8.93018V21.3025C5.58142 21.8675 6.03946 22.3255 6.60449 22.3255H22.977C23.542 22.3255 24 21.8675 24 21.3025V16.7441L15.0698 10.6046Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0698 0H6.60449C6.03946 0 5.58142 0.458041 5.58142 1.02307V5.5814L15.0698 11.1628L20.093 12.8372L24 11.1628V5.5814L15.0698 0Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58142 5.58154H15.0698V11.1629H5.58142V5.58154Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.3723 4.46533H5.58142V18.4188H12.3723C12.9366 18.417 13.3935 17.96 13.3954 17.3958V5.4884C13.3935 4.92414 12.9366 4.46717 12.3723 4.46533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8142 5.02344H5.58142V18.9769H11.8142C12.3784 18.9751 12.8354 18.5181 12.8372 17.9539V6.0465C12.8354 5.48224 12.3784 5.02527 11.8142 5.02344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8142 5.02344H5.58142V17.8606H11.8142C12.3784 17.8588 12.8354 17.4018 12.8372 16.8376V6.0465C12.8354 5.48224 12.3784 5.02527 11.8142 5.02344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.256 5.02344H5.58142V17.8606H11.256C11.8203 17.8588 12.2773 17.4018 12.2791 16.8376V6.0465C12.2773 5.48224 11.8203 5.02527 11.256 5.02344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02307 5.02344H11.256C11.821 5.02344 12.2791 5.48148 12.2791 6.0465V16.2794C12.2791 16.8445 11.821 17.3025 11.256 17.3025H1.02307C0.458041 17.3025 0 16.8445 0 16.2794V6.0465C0 5.48148 0.458041 5.02344 1.02307 5.02344Z",
    fill: "url(#paint0_linear_3217_23478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16858 14.4883L5.32077 11.1534L3.34886 7.83691H4.93509L6.01118 9.95784C6.11054 10.1593 6.17862 10.3089 6.21547 10.4077H6.22942C6.30011 10.247 6.37453 10.0909 6.45267 9.93942L7.60299 7.83804H9.05918L7.03704 11.135L9.11054 14.4883H7.56114L6.31816 12.1603C6.25961 12.0612 6.20993 11.9572 6.1697 11.8494H6.15129C6.11487 11.955 6.06657 12.0561 6.00728 12.1508L4.72747 14.4883H3.16858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.977 0H15.0698V5.5814H24.0001V1.02307C24.0001 0.458041 23.542 0 22.977 0Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0698 11.1626H24.0001V16.744H15.0698V11.1626Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3217_23478",
    x1: 2.13312,
    y1: 4.22403,
    x2: 10.1459,
    y2: 18.1019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3217_23478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22.3256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.216ce36fa96ece65f3d0243acee30bad.svg";
export { ForwardRef as ReactComponent };